module.exports = __webpack_public_path__ + "223bd9e7f2eb96fbfdfadef3a3da94f2.svg";